import { render, staticRenderFns } from "./folderBox.vue?vue&type=template&id=3a95a079&scoped=true"
import script from "./folderBox.vue?vue&type=script&lang=js"
export * from "./folderBox.vue?vue&type=script&lang=js"
import style0 from "./folderBox.vue?vue&type=style&index=0&id=3a95a079&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a95a079",
  null
  
)

export default component.exports